import React, { useState, useEffect } from 'react'
import { ImEqualizer2 } from 'react-icons/im'
import { IoIosSettings } from 'react-icons/io'
import { IoTrashSharp } from 'react-icons/io5'
import { useHistory, useParams } from 'react-router-dom'
import NewFormWizard from '../../components/formWizard/NewFormWizard'
import NewFormWizardChild from '../../components/formWizard/NewFormWziardChild'
import Layout from '../../components/layouts/Layout'
import http, { URL_S3 } from '../../config/BaseUrl'
import BrustGifModal from '../events/components/Modal/BrustGifModal'
import BrustGifSettingsModal from '../events/components/Modal/BrustGifSettingsModal'

function BrustGifEdit() {
  const history = useHistory()
  const { id } = useParams()
  
  const [selectedBrustGif, setSelectedBrustGif] = useState([])
  const [loading, setLoading] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [brustGifId, setBrustGifId] = useState(null)
  const [selectedSettings, setSelectedSettings] = useState(null)
  const [brustGifTemplateErr, setBrustGifTemplateErr] = useState(false)
  const [frame, setFrame] = useState(null);
  const [selectedFrame, setSelectedFrame] = useState([])

  
  const handelTemplate = (e) => {
    e.preventDefault();
    if(selectedBrustGif.length > 0){
      setLoading(true)
      http.post(`event/brust-gif/update/${id}`, { brust_gif: selectedBrustGif, eventId: id }).then(res => {
        history.push(`/show/event/${id}`, 'Information Updated.')
          setLoading(false)
      }).catch()
    }else{
      setBrustGifTemplateErr(true)
    }
  }

  
  useEffect(() => {

    http.get(`event-brust-gif/${id}`)
      .then( res => {
        let responseData = [];
        res.data.galleryItems.length > 0 &&
          res.data.galleryItems.forEach( item =>{
            responseData.push({id: item.brust_gif_id, photo: item.photo, image: item.burst_gif.preview_image, settings: item.brust_gif_setting, custom_frame: item.burst_gif.custom_frame.length > 0 ? item.burst_gif.custom_frame[0] : null})
          }) 
        setSelectedBrustGif(responseData)
        setSelectedFrame(responseData)
      })
      .catch(err=>{
        console.log(err.response)
      })

  }, [])

  const setBrustGifByProps = (data) => {
      setSelectedBrustGif(data)
      setSelectedFrame(data);
      setBrustGifTemplateErr(false)
  }

  const removeProps = (id) => {
      let copyProps = [...selectedBrustGif]
      copyProps.splice(id, 1)
      setSelectedBrustGif(copyProps)
      setSelectedFrame(copyProps)

  }

  const submitTrigger = (data) => {
    let copyData = [...selectedBrustGif]

    let indexItem = copyData.findIndex(item=> item.id == data.brustGifId)

    if (indexItem >= 0) {
        copyData[indexItem].settings= data
    }

    setSelectedBrustGif(copyData)

  }

  const settingsOpen = (item) => {
    setOpenModal(true)
    setBrustGifId(item.id)
    setFrame(item);
    setSelectedSettings(item.settings)
  }

  const customFrame = (data, id) => {
    let frameData = [...selectedFrame]
    let dataIndex = frameData.findIndex(item => item.id === id)

    frameData[dataIndex].custom_frame = data
    setSelectedFrame([...frameData])
  }
  
  return (
      <Layout>
        <NewFormWizard />
        <NewFormWizardChild />

        <form onSubmit={handelTemplate}>
            <section className="mt-4">
                <div className="row justify-content-center">
                    <div className="text-center col-12 col-md-10">
                      <div className="card">
                        <div className="card-body">
                          <div className="">
                            <p className="mb-0 display-4 text-primary event-form-title">Speed Burst Chooser</p>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div className="col-md-10">
                        <div className="p-4 bg-white border d-flex flex-column radius-10 ">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <ImEqualizer2 size={30} />
                                    <p className="mb-0 ml-2 font-size-16">Animation Library</p>
                                </div>
                                <div className="float-right">
                                    <button type="button" className="mr-3 btn btn-outline-primary" data-toggle="modal" data-target="#event-frame-modal">Select Speed Burst</button>
                                    <BrustGifModal setData={setBrustGifByProps} selectedBrustGif={selectedBrustGif} />
                                </div>
                            </div>
                            {brustGifTemplateErr &&
                                <p className={`pt-2 mb-0 text-danger font-weight-bold text-right fade ${brustGifTemplateErr ? 'show' : 'hide'}`}>Choose any animation </p>
                            }
                            <div className="prop__area">
                                <div className="flex-wrap props-list d-flex">
                                    {
                                        selectedBrustGif.length > 0 ?
                                            selectedBrustGif.map((propItem, index) => (
                                                <div className="prop__item" key={`digital-props-index-${index}`}>
                                                    <img src={`${URL_S3}image/burstGif/preview_image/${propItem.image}`} className="img-fluid" alt="props-data" />
                                                    {
                                                      propItem.custom_frame &&
                                                      <img 
                                                          src={`${URL_S3}image/burstGif/frame_image/custom_frame/${propItem.custom_frame.frame}`} className="img-fluid" alt='no'
                                                          style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', maxHeight: '150px', maxWidth: `150px`, objectFit: 'contain'}} 
                                                      />
                                                    }
                                                    <div className="remove-props d-flex justify-content-around align-items-center">
                                                      <span className="font-small" onClick={removeProps.bind(this, index)}>
                                                        <IoTrashSharp />
                                                      </span>
                                                      <span className="font-small" onClick={settingsOpen.bind(this, propItem)}>
                                                        <IoIosSettings />
                                                      </span>
                                                    </div>
                                                </div>
                                            ))

                                            :
                                            <div className="prop__no__item">
                                                <h4>No Speed Burst Selected.</h4>
                                            </div>
                                    }

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="my-5 row justify-content-center">
                  <div className="col-md-10">
                      <button type="submit" className="float-right px-5 btn btn-primary radius-10">
                          {loading ?
                              <>
                                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                  Updating...
                              </>
                              : "Update"
                          }
                      </button>
                  </div>
                </div>

                <BrustGifSettingsModal 
                  isOpen={openModal} 
                  brustGifId={brustGifId} 
                  closeModal={setOpenModal} 
                  submitTrigger={submitTrigger} 
                  selectedSettings={selectedSettings}
                  eventId={id}
                  setSelectedFrame={setFrame}
                  selectedFrame={frame}
                  setCustomFrame={customFrame}
                  canSetCustomFrame={true}
                />

            </section>
        </form>
    </Layout>
    )
}

export default BrustGifEdit
